import React from "react";
import { ICrud, ITableColumn, BaseGrid, BaseToolbar, BaseScreen } from "react-epharma-components";
import CrudForm from "./Crud";
import SearchForm from "./Search";
//import BaseExport from 'react-epharma-components/lib/components/export';

export default class AssociationChainScreen extends React.Component {
  private columns: ITableColumn[] = [
    { name: "id", displayName: "Id", sortable: true, width: "2%" },
    { name: "chainId", displayName: "Rede", sortable: true, width: "15%", onRender: (value, model) => { console.log("[DEBUG] Rede onRender - value:", value, "model:", model, "model.chain:", model.chain, "keys:", Object.keys(model)); return `${model.chainId} / ${model.chain}`; }, },
    { name: "clientId", displayName: "Cliente", sortable: true, width: "15%", onRender: (value, model) => { console.log("[DEBUG] Cliente onRender - model.client:", model.client); return value > 0 ? `${model.clientId} / ${model.client}` : ``; }, },
    { name: "benefitId", displayName: "Plano (Benefícioooo)", sortable: true, width: "15%", onRender: (value, model) => { return value > 0 ? `${model.benefitId} / ${model.benefit}` : ``; }, },
    { name: "productId", displayName: "Produto", sortable: true, width: "15%", onRender: (value, model) => { return value > 0 ? `${model.productId} / ${model.product}` : ``; }, },
    { name: "presentationId", displayName: "Apresentação", sortable: true, width: "15%", onRender: (value, model) => { return value > 0 ? `${model.presentationId} / ${model.presentation}` : ``; }, },
    { name: "commisionValue", displayName: "% Comissão", sortable: true, width: "7%", onRender: (value) => { return value?.toString().replace('.', ','); }, },
    { name: "startDate", displayName: "Início da Comissão", sortable: true, width: "10%", type: "datetime" },
    { name: "endDate", displayName: "Fim da Comissão", sortable: true, width: "10%", type: "datetime" },
  ];

  private crud: ICrud = {
    form: <CrudForm />,
    create: {
      show: true
    },
    read: {
      show: true,
    },
    log: {
      show: true,
      id: 4,
      keys: "chainId|id|clientId|benefitId|productId|presentationId"
    },
    update: {
      show: true,
    },
    exportGrid: {
      show: true,
    },
  };

  render() {
    const baseEndpoint =
      window.chainService.base +
      window.chainService.comissionChain;

    return (
      <BaseScreen title="" description="">
        <BaseGrid
          name="Search"
          baseEndpoint={baseEndpoint}
          toolbar={
            <BaseToolbar
              crud={this.crud}
              search={{
                show: true,
                form: <SearchForm />,
              }}

            />
          }
          columns={this.columns}
          {...this.props}
        />
      </BaseScreen>
    );
  }
}
